import React from 'react';

import { translate } from '@vimeo/i18n-runtime';
import { Button } from '@vimeo/iris/components';

import { MenuContainer, MenuOption, MenuPanel, MenuWrapper } from '../Styles';
import { TextTrack } from '../types';

type Props = {
  textTracks: TextTrack[];
};

const TextTracks = ({ textTracks }: Props) => (
  <section className="secondary-action">
    <span className="secondary-action-text">{translate('Download captions and subtitles')}</span>

    <MenuWrapper>
      <Button format="basic" variant="hyperminimal">
        {translate('Choose file')}
      </Button>
      <MenuContainer className="menu-container">
        <MenuPanel>
          {textTracks.map((textTrack, i) => (
            <MenuOption key={`text_track_${i}`}>
              <a
                className="iris_menu-link iris_link"
                href={textTrack.downloadUrl?.replace('http://', 'https://')}
              >
                {textTrack.displayName}
              </a>
            </MenuOption>
          ))}
        </MenuPanel>
      </MenuContainer>
    </MenuWrapper>
  </section>
);

export default TextTracks;
